/**
 *Angular module*/
import {Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, Output, ViewChild} from '@angular/core';
/**
 *Shared*/
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {NgbDate, NgbDatepickerConfig, NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {NotificationService} from '../../services/notification.service';
import {SessionStorageService} from '../../services/session-storage.service';
import {NotifyMsg} from '../../interfaces/notify-msg';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-range-date-picker',
    styleUrls: ['./range-date-picker.component.scss'],
    template: `
        <div class="input-group" [ngClass]="{'date-expansion':isEnabled }" >
            <input class="form-control" placeholder="yyyy-mm-dd" [readonly]="true"
                   [value]="display.searchFrom.format('DD-MM-YYYY')+' - '+display.searchTo.format('DD-MM-YYYY')">
            <input class="d-none" placeholder="yyyy-mm-dd" [name]="name"
                   [(ngModel)]="model" (ngModelChange)="onModelChange($event)" [startDate]="searchFrom" [maxDate]="maxDays > 0?today:maxDate"
                   [minDate]="minDate" ngbDatepicker #dp="ngbDatepicker" autoClose="false" [footerTemplate]="footerTemplate"
                   [displayMonths]="2" [dayTemplate]="t" readonly>
            <div class="input-group-append">
                <span class="input-group-text" (click)="dp.toggle();isEnabled = !isEnabled "><i class="icon-regular i-Calendar-4" aria-hidden="true"></i></span></div>
        </div>
        <!--<div class="input-group" [ngClass]="{'date-expansion':isEnabled }">
            <input class="form-control" [value]="display.searchFrom.format('DD-MM-YYYY')+' - '+display.searchTo.format('DD-MM-YYYY')" readonly>
            <div class="input-group-append">
                <span class="input-group-text"><i class="icon-regular i-Calendar-4" aria-hidden="true"></i></span>
            </div>
        </div>
        <ngb-datepicker #dp (select)="onModelChange($event)" [displayMonths]="2" [dayTemplate]="t"
                        [minDate]="minDate" [footerTemplate]="footerTemplate"></ngb-datepicker>-->
        <ng-template #t let-date let-focused="focused">
            <span class="custom-day" [ngClass]="{'hide-range':maxDays > 0}"
                  [class.focused]="focused" [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)"
                  (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">{{ date.day }}</span>
        </ng-template>
        <ng-template #footerTemplate>
            <ng-container *ngIf="!hideOptions">
                <hr class="my-2">
                <div class="d-inline-block w-25 mr-1 ml-1" ngbDropdown #dayFilter="ngbDropdown">
                    <button type="button" class="btn btn-outline-primary search-drop-down-input w-100" ngbDropdownAnchor (focus)="dayFilter.open()" translate>
                        DAY-WEEK
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dayFilter">
                        <button class="dropdown-item" *ngFor="let mainFilter of mainFilterArray.day"
                                (click)="setRange(mainFilter);" translate>{{mainFilter.toUpperCase()}}
                        </button>
                    </div>
                </div>
                <div class="d-inline-block w-25 mr-1" ngbDropdown #monthFilter="ngbDropdown">
                    <button type="button" class="btn btn-outline-primary search-drop-down-input w-100" ngbDropdownAnchor (focus)="monthFilter.open()" translate>
                        MONTH
                    </button>
                    <div ngbDropdownMenu aria-labelledby="monthFilter">
                        <button class="dropdown-item" *ngFor="let mainFilter of mainFilterArray.month"
                                (click)="setRange(mainFilter);" translate>{{mainFilter.toUpperCase()}}
                        </button>
                    </div>
                </div>
                <div class="d-inline-block w-25 mr-1" ngbDropdown #yearFilter="ngbDropdown">
                    <button type="button" class="btn btn-outline-primary search-drop-down-input w-100" ngbDropdownAnchor (focus)="yearFilter.open()" translate>
                        YEAR
                    </button>
                    <div ngbDropdownMenu aria-labelledby="yearFilter">
                        <button class="dropdown-item" *ngFor="let mainFilter of mainFilterArray.year"
                                (click)="setRange(mainFilter);" translate>{{mainFilter.toUpperCase()}}
                        </button>
                    </div>
                </div>
                <!--<button type="button" class="btn btn-primary btn-sm m-1" (click)="setRange('this-year')">This year</button>-->
                <!--<button type="button" class="btn btn-primary btn-sm m-1" (click)="setRange('this-month')">This month</button>-->
                <!--<button type="button" class="btn btn-primary btn-sm m-1" (click)="setRange('this-week')">This week</button>-->
                <!--<button class="btn btn-primary btn-sm m-1" (click)="setRange('next-week')">Next week</button>-->
                <!--<button class="btn btn-primary btn-sm m-1" (click)="setRange('next-month')">Next month</button>-->
            </ng-container>
            <button type="button" class="btn btn-outline-danger btn-sm m-1 float-right" (click)="dp.close();isEnabled = false"><span class="fa fa-times"></span></button>
        </ng-template>`,
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RangeDatePickerComponent), multi: true}, NgbDatepickerConfig]
})
export class RangeDatePickerComponent {
    today = {year: moment().get('year'), month: moment().get('month') + 1, day: moment().get('date') + 1};
    @Input() name = '';
    @Input() model: any = this.today;
    @Input() range: string;
    @Input() disablePastDates = false;
    @Input() hideOptions = false;
    @Input() allowRange = false;
    @Input() maxDays = 0;
    newMaxDays = this.maxDays;
    @Input() isEnabled = true;
    minDate = undefined;
    maxDate = undefined;
    private defaultLanguage = 'en';
    errorMap = {en: 'Maximum {{_DAYS_}} are allowed', cn: '允许最大{{_DAYS_}}'};
    mainFilterArray = {
        day: ['today', 'yesterday', 'this-week', 'last-week', 'next-week'],
        month: ['this-month', 'last-month', 'next-month'],
        year: ['this-year', 'last-year']
    };

    /**
     * Date variables*
     */
    searchFrom = {year: moment().get('year'), month: moment().get('month'), day: moment().get('date') + 1};
    searchTo = {year: moment().get('year'), month: moment().get('month') + 1, day: moment().get('date') + 1};
    display = {
        searchFrom: moment().year(this.searchFrom.year).month(this.searchFrom.month - 1).date(this.searchFrom.day),
        searchTo: moment().year(this.searchTo.year).month(this.searchTo.month - 1).date(this.searchTo.day)
    };
    hoveredDate: NgbDate;

    @Output() setDate: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('dp') dp: NgbInputDatepicker;

    @HostListener('document:click', ['$event'])
    onClick(event: any) {
        if (this._eref.nativeElement.contains(event.target)) {
            return true;
        }
    }

    constructor(private _eref: ElementRef, config: NgbDatepickerConfig,
                private sessionStorageService: SessionStorageService,
                private translate: TranslateService,
                private notificationService: NotificationService) {
        this.defaultLanguage = sessionStorageService.getLanguageSession();
        config.outsideDays = 'hidden';
        // weekends are disabled
        // config.markDisabled = (date: NgbDate) => calendar.getWeekday(date) >= 6;
        setTimeout(() => {
            if (this.disablePastDates) {
                this.minDate = this.today;
            }

            if (this.maxDays > 0) {
                const nextDate = moment().year(this.searchFrom.year).month(this.searchFrom.month - 1).date(this.searchFrom.day);
                nextDate.add(this.maxDays - 1, 'day');
                this.searchTo = new NgbDate(nextDate.get('year'), nextDate.get('month') + 1, nextDate.get('date'));
                this.display.searchTo = moment().year(this.searchTo.year).month(this.searchTo.month - 1).date(this.searchTo.day);
            }
            this.setDate.emit({
                fromDate: this.display.searchFrom.format('YYYY-MM-DD'),
                toDate: this.display.searchTo.format('YYYY-MM-DD')
            });
            if (this.isEnabled) {
                this.dp.open();
            }
            this.newMaxDays = this.maxDays;
        }, 600);
    }

    onModelChange(date: NgbDate) {
        date = new NgbDate(date.year, date.month, date.day);
        if (!this.searchFrom && !this.searchTo) {
            this.searchFrom = date;
        } else if (this.searchFrom && !this.searchTo && date.after(this.searchFrom)) {
            this.searchTo = date;
        } else {
            this.searchTo = null;
            this.searchFrom = date;
        }
        if (this.maxDays > 0) {
            let nextDate = moment().year(date.year).month(date.month - 1).date(date.day);
            if (this.searchTo != null) {
                const duration = moment.duration(nextDate.diff(moment().year(this.searchFrom.year).month(this.searchFrom.month - 1).date(this.searchFrom.day)));
                if (duration.asDays() >= this.maxDays - 1) {
                    nextDate = moment().year(this.searchFrom.year).month(this.searchFrom.month - 1).date(this.searchFrom.day);
                    nextDate.add(this.maxDays - 1, 'day');
                    this.translate.get(['WARNING']).subscribe((response: NotifyMsg) =>
                        this.notificationService.basicNoty('WARNING', this.errorMap[this.defaultLanguage].replace('{{_DAYS_}}', this.maxDays), response['WARNING']));
                }
                this.searchTo = new NgbDate(nextDate.get('year'), nextDate.get('month') + 1, nextDate.get('date'));
            }
        }

        if (this.searchFrom != null && this.searchTo != null) {
            this.display = {
                searchFrom: moment().year(this.searchFrom.year).month(this.searchFrom.month - 1).date(this.searchFrom.day),
                searchTo: moment().year(this.searchTo.year).month(this.searchTo.month - 1).date(this.searchTo.day)
            };
            this.setDate.emit({
                fromDate: this.display.searchFrom.format('YYYY-MM-DD'),
                toDate: this.display.searchTo.format('YYYY-MM-DD')
            });
        }
    }

    setRange(type: string) {
        let startOfMonth, endOfMonth;

        switch (type) {
            case 'this-year':
                startOfMonth = endOfMonth = moment();
                startOfMonth = moment(startOfMonth.startOf('year'));
                endOfMonth = moment(endOfMonth.endOf('year'));

                this.searchFrom = {year: startOfMonth.get('year'), month: startOfMonth.get('month') + 1, day: startOfMonth.get('date')};
                this.searchTo = {year: endOfMonth.get('year'), month: endOfMonth.get('month') + 1, day: endOfMonth.get('date')};
                break;

            case 'this-month':
                startOfMonth = this.disablePastDates ? startOfMonth = moment() : startOfMonth = moment().startOf('month');
                endOfMonth = this.disablePastDates ? endOfMonth = moment() : endOfMonth = moment().endOf('month');

                this.searchFrom = {year: startOfMonth.get('year'), month: startOfMonth.get('month') + 1, day: startOfMonth.get('date')};
                this.searchTo = {year: endOfMonth.get('year'), month: endOfMonth.get('month') + 1, day: endOfMonth.get('date')};
                break;

            case 'this-week':
                startOfMonth = this.disablePastDates ? startOfMonth = moment() : startOfMonth = moment().startOf('week');
                endOfMonth = this.disablePastDates ? endOfMonth = moment() : endOfMonth = moment().endOf('week');

                this.searchFrom = {year: startOfMonth.get('year'), month: startOfMonth.get('month') + 1, day: startOfMonth.get('date')};
                this.searchTo = {year: endOfMonth.get('year'), month: endOfMonth.get('month') + 1, day: endOfMonth.get('date')};
                break;

            case 'today':
                startOfMonth = moment();
                endOfMonth = moment();

                this.searchFrom = {year: startOfMonth.get('year'), month: startOfMonth.get('month') + 1, day: startOfMonth.get('date')};
                this.searchTo = {year: endOfMonth.get('year'), month: endOfMonth.get('month') + 1, day: endOfMonth.get('date')};
                break;

            case 'yesterday':
                startOfMonth = moment();
                endOfMonth = moment();

                this.searchFrom = {year: startOfMonth.get('year'), month: startOfMonth.get('month') + 1, day: startOfMonth.get('date') - 1};
                this.searchTo = {year: endOfMonth.get('year'), month: endOfMonth.get('month') + 1, day: endOfMonth.get('date') - 1};
                break;

            case 'next-month':
                startOfMonth = endOfMonth = moment().set('month', moment().get('month') + 1);
                startOfMonth = moment(startOfMonth.startOf('month'));
                endOfMonth = moment(endOfMonth.endOf('month'));

                this.searchFrom = {year: startOfMonth.get('year'), month: startOfMonth.get('month') + 1, day: startOfMonth.get('date')};
                this.searchTo = {year: endOfMonth.get('year'), month: endOfMonth.get('month') + 1, day: endOfMonth.get('date')};
                break;

            case 'next-week':
                startOfMonth = endOfMonth = moment();
                startOfMonth = moment().set('week', startOfMonth.get('week') + 1).startOf('week');
                endOfMonth = moment().set('week', endOfMonth.get('week') + 1).endOf('week');

                this.searchFrom = {year: startOfMonth.get('year'), month: startOfMonth.get('month') + 1, day: startOfMonth.get('date')};
                this.searchTo = {year: endOfMonth.get('year'), month: endOfMonth.get('month') + 1, day: endOfMonth.get('date')};
                break;

            case 'last-year':
                startOfMonth = endOfMonth = moment();
                startOfMonth = moment(startOfMonth.startOf('year'));
                endOfMonth = moment(endOfMonth.endOf('year'));

                this.searchFrom = {year: startOfMonth.get('year') - 1, month: startOfMonth.get('month') + 1, day: startOfMonth.get('date')};
                this.searchTo = {year: endOfMonth.get('year') - 1, month: endOfMonth.get('month') + 1, day: endOfMonth.get('date')};
                break;

            case 'last-month':
                startOfMonth = endOfMonth = moment().set('month', moment().get('month') - 1);
                startOfMonth = moment(startOfMonth.startOf('month'));
                endOfMonth = moment(endOfMonth.endOf('month'));

                this.searchFrom = {year: startOfMonth.get('year'), month: startOfMonth.get('month') + 1, day: startOfMonth.get('date')};
                this.searchTo = {year: endOfMonth.get('year'), month: endOfMonth.get('month') + 1, day: endOfMonth.get('date')};
                break;

            case 'last-week':
                startOfMonth = endOfMonth = moment();
                startOfMonth = moment().set('week', startOfMonth.get('week') - 1).startOf('week');
                endOfMonth = moment().set('week', endOfMonth.get('week') - 1).endOf('week');

                this.searchFrom = {year: startOfMonth.get('year'), month: startOfMonth.get('month') + 1, day: startOfMonth.get('date')};
                this.searchTo = {year: endOfMonth.get('year'), month: endOfMonth.get('month') + 1, day: endOfMonth.get('date')};
                break;

            default:
                break;
        }

        this.display = {
            searchFrom: moment().year(this.searchFrom.year).month(this.searchFrom.month - 1).date(this.searchFrom.day),
            searchTo: moment().year(this.searchTo.year).month(this.searchTo.month - 1).date(this.searchTo.day)
        };
        this.setDate.emit({
            fromDate: this.display.searchFrom.format('YYYY-MM-DD'),
            toDate: this.display.searchTo.format('YYYY-MM-DD')
        });
    }

    isHovered(date: NgbDate) {
        return this.searchFrom && !this.searchTo && this.hoveredDate && date.after(this.searchFrom) && date.before(this.hoveredDate);
    }

    isInside(date: NgbDate) {
        return date.after(this.searchFrom) && date.before(this.searchTo);
    }

    isRange(date: NgbDate) {
        return date.equals(this.searchFrom) || date.equals(this.searchTo) || this.isInside(date) || this.isHovered(date);
    }
}
